module.exports = __webpack_public_path__ + "static/media/mx.a5839023.png";